export default __webpack_public_path__ + "static/media/filter.90fe0ab5.svg";